/** @jsx jsx */

import { ReactNode } from 'react';

import { css, jsx } from '@emotion/core';

import { useAvroEvent } from 'app/developer-v3/hooks';

import NavLink from '../NavLink';

const Styles = {
  menuItem: css`
    padding: 6px 30px;
  `,
};

type Section = 'build' | 'manage' | 'embed';

type Props = {
  hasLeftIndent?: boolean;
  item: {
    badge?: ReactNode;
    label: string;
    url?: string;
    isActive: boolean;
    isEnabled: boolean;
    section: Section;
    tooltip?: string;
  };
};

const defaultProps = {
  hasLeftIndent: false,
  subMenu: {
    items: [],
  },
};

const MenuItem = (props: Props) => {
  const { hasLeftIndent, item } = props;
  const { emitPartnerUserInteractionEvent } = useAvroEvent();

  return item.url === '' ? (
    <span css={Styles.menuItem}>{item.label}</span>
  ) : (
    <NavLink
      badge={item.badge}
      gridTemplateColumn={item.badge && '1fr auto'}
      hasLeftIndent={hasLeftIndent}
      href={item.url}
      isActive={item.isActive}
      isLocked={!item.isEnabled}
      label={item.label}
      onClick={() =>
        emitPartnerUserInteractionEvent({
          interactionGoal: 'Navigate to a section in the developer platform UI',
          interactionName: 'sidebar_item_clicked',
          interactionRawText: item.label,
          eventAction: 'click',
          optionSelected: `${item.section} - ${item.label.toLowerCase()}`,
        })
      }
      tooltip={item.tooltip}
    />
  );
};

MenuItem.defaultProps = defaultProps;

export default MenuItem;
